import {
  Module,
  VuexModule,
  Action,
} from 'vuex-module-decorators';

import {
  BASE_URL,
  USER_SEAMLESS_PROBLEM_ADD,
  USER_SEAMLESS_PROBLEM_FETCH,
  USER_SEAMLESS_PROBLEM_REMOVE,
  USER_SEAMLESS_PROBLEM_SEARCH,
  M_POST,
  M_DELETE,
} from '@/utils/api';

import { IUserSeamlessProblemResponse, IUserSeamlessProblemRequest } from '@/interface/Admin';

import Vue from 'vue';

@Module({ name: 'admin' })
export default class Account extends VuexModule {
  userList: Array<IUserSeamlessProblemResponse> = [];

  @Action
  async AddUser(user: IUserSeamlessProblemRequest) {
    try {
      const { data } = await Vue.axios({
        url: BASE_URL + USER_SEAMLESS_PROBLEM_ADD,
        data: user,
        method: M_POST,
      });
      return data;
    } catch (err) {
      return err;
    }
  }

  @Action
  async SearchUser(user: IUserSeamlessProblemRequest) {
    try {
      const { data } = await Vue.axios({
        url: BASE_URL + USER_SEAMLESS_PROBLEM_SEARCH,
        data: user,
        method: M_POST,
      });
      return data;
    } catch (err) {
      return err;
    }
  }

  @Action
  async removeUser(user: IUserSeamlessProblemRequest) {
    try {
      const { data } = await Vue.axios({
        url: BASE_URL + USER_SEAMLESS_PROBLEM_REMOVE,
        data: user,
        method: M_DELETE,
      });
      return data;
    } catch (err) {
      return err;
    }
  }

  @Action
  async FetchUser(user: IUserSeamlessProblemRequest) {
    try {
      const { data } = await Vue.axios({
        url: BASE_URL + USER_SEAMLESS_PROBLEM_FETCH,
        data: user,
        method: M_POST,
      });
      return data;
    } catch (err) {
      return err;
    }
  }
}
